<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "GmcsWebH5Index",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
